import { ConnectionStatus, Network } from "@capacitor/network";
import { action, observable, runInAction } from "mobx";
import { history } from "@state/utils";
import { getCurrentCulture } from "@utils";
import type { RootStore } from "@state/stores/types";

export default class CapacitorConnectionStatusStore {
	@observable connectionStatus: ConnectionStatus | null = null;
	@observable listener: { remove: () => Promise<void> } | null = null;

	private connectionTimer: NodeJS.Timeout | null = null;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	setConnectionStatus(connectionStatus: ConnectionStatus) {
		this.connectionStatus = connectionStatus;
	}

	@action.bound
	async onInitialize() {
		try {
			const status = await Network.getStatus();
			runInAction(() => {
				this.setConnectionStatus(status);
			});

			this.handleConnectionChange(status);

			this.listener = await Network.addListener(
				"networkStatusChange",
				(status) => {
					runInAction(() => {
						this.setConnectionStatus(status);
					});

					this.handleConnectionChange(status);
				}
			);
		} catch (error) {
			console.error(error);
		}
	}

	@action.bound
	handleConnectionChange(status: ConnectionStatus) {
		if (this.connectionTimer) {
			clearTimeout(this.connectionTimer);
			this.connectionTimer = null;
		}

		this.connectionTimer = setTimeout(() => {
			if (!status.connected) {
				history.push(
					`/${getCurrentCulture()}/offline?lastVisitedUrl=${location.pathname}`
				);
			}
		}, 4000);
	}

	@action.bound
	async onDispose() {
		await Network.removeAllListeners();

		if (this.listener) {
			await this.listener.remove();
			this.listener = null;
		}

		if (this.connectionTimer) {
			clearTimeout(this.connectionTimer);
			this.connectionTimer = null;
		}
	}
}
